import 'lightgallery/src/sass/lightgallery.scss';
import 'lightgallery';
import 'lg-thumbnail';
import 'lg-video';

export function initGallery() {

    $(document).ready(function () {

        const data = JSON.parse(document.getElementById('imageFolders').innerHTML);
        $('#memberGalleryTitle').text(data[0].Title);
        DisplayResults(data[0].ID);
        $.each(data, function (i) {
            $('#memberGalleryDropdown').append($('<option>', {
                value: data[i].ID,
                text: data[i].Title
            }));
        });

        $('#memberGalleryDropdown').on('change', function () {
            var value = $(this).find(":selected").val();
            DisplayResults(value);
        });
    });

    function DisplayResults(value) {
        var url_pattern = value;
        const url = window.location.origin + '/MemberImageGallery/data/' + url_pattern;
        var toRefresh = ['#collectionGallery'];
        var loadingSelector = '.loading';
        loadAjaxContent(url, toRefresh, loadingSelector);
    }

    function loadAjaxContent(url, toRefresh, loadingSelector) {
        $.ajax({
            url: url,
            type: 'GET',
            success: function success(response) {

                $('.loading-animation').removeClass('d-none');

                var data = JSON.parse(response);

                var imageContainer = $('#collectionGallery');
                imageContainer.empty();

                $.each(data, function (id, folder) {
                    $('#memberGalleryTitle').text(folder.Title);
                    $.each(folder.Images, function (id, image) {
                        var imgs = '<a class="gallery-item" href="' + image.URL + '" data-sub-html="<h4>' + image.Title + '</h4>"><img src="' + image.Thumb + '"/></a>';
                        $('#collectionGallery').append(imgs);
                    });
                });
            },

            error: function error() {
                if (loadingSelector) {
                    $(loadingSelector).addClass('d-none');
                }
            }
        });
    }

    $(document).ajaxComplete(function() {
        $('.loading-animation').addClass('d-none');
        if($(".image-gallery").data("lightGallery")) {
            $(".image-gallery").data("lightGallery").destroy(true);
        }
        $('.image-gallery').lightGallery({
            download: false
        });
    });
}
